import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function BooksPage() {
  const books = [
    {
      title: "Guide to American Vineyards",
      subtitle: "A Guide to the Best Wineries for Touring and Tasting",
      author: "Pamela Stovall",
      publisher: "Globe Pequot Press",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/395eb3183ee28d99c85b1f246c15c770.jpeg",
      quote: "An enthusiastic and useful volume that should be the constant companion of any wine lover setting out to explore American wine country.",
      quoteAuthor: "Anthony Dias Blue, Wine and Spirits Editor, Bon Appetit magazine",
      description: "Experience America's 100 Best Vineyards\n\nWander amid pastoral landscapes, meet interesting people, and taste fine wines at the more than one hundred American vineyards featured in this informative guide. Perfect for longtime oenophiles and novice wine enthusiasts alike, it covers 34 states, letting you plan an afternoon, weekend or week-long adventure of winery touring."
    },
    {
      title: "Zero Proof",
      subtitle: "200 Nonalcoholic Drinks from America's Most Famous Bars and Restaurants",
      author: "Pamela Stovall and Richard Lalich",
      publisher: "St. Martin's Press",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/d9c4ad3a329ba693688d93e998fe9bc3.jpeg",
      quote: "",
      quoteAuthor: "",
      description: "Fed up with Fuzzy Navels that leave you feeling fuzzy? A little too familiar with the hair of the dog that bit you? Well, the jigger's up! With the help of this lively, one-of-a-kind book, you're about to discover dozens of irresistible nonalcoholic drinks—drinks that won't dull your senses, won't give you a hangover, and won't have you dancing on tabletops.\n\nZero Proof goes way beyond yesterday's boring Virgin Marys and tepid Shirley Temples, offering a dazzling array of delicious-tasting, gorgeous-looking nonalcoholic drink recipes that have all the zest and zing of \"the real thing\"—and then some. Authors Pamela Stovall and Richard Lalich gathered recipes from all the hottest bars and restaurants, collecting house specials, bartenders' secret recipes (the drinks bartenders mix for themselves), and customers' cult favorites. Included are recipes from New York's The Four Seasons, CRGB's, The '21' Club, and The Rainbow Room; LA's Spago, Hotel Bel-Air, and L'Orangerie; Chicago's Sage's Sages, Second City, and Bossa Nova; Atlanta's Buckhead Diner, the Dining Room at the Ritz-Carlton, and Pricci; Seattle's Top of the Needle Lounge, and dozens of other world-famous culinary hot spots."
    },
    {
      title: "Short Bike Rides in Michigan",
      subtitle: "First Edition",
      author: "Pamela Stovall",
      publisher: "Globe Pequot Press",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/5f6dc531ec20e0dff5014ed99494b824.jpeg",
      quote: "",
      quoteAuthor: "",
      description: "Leave your expectations behind and discover why Michigan is a great place to ride your bike.\n\nWith its gently rolling hills, sweeping vistas of the Great Lakes, dense hardwood forests, and shimmering rivers and streams, Michigan is a glorious state for bicycling. These forty well-planned tours, which range in length from 7 to 30 miles, will take you along the best stretches the Wolverine State's 88,000 miles of country roads."
    },
    {
      title: "Short Bike Rides in Michigan",
      subtitle: "Second Edition",
      author: "Pamela Stovall",
      publisher: "Globe Pequot Press",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/21bb63bacacde416728821b0a5d0cb69.jpeg",
      quote: "[This book] … is compact and flexible, making it the perfect companion on a ride.",
      quoteAuthor: "Ann Arbor News",
      description: "The Best Road And Trail Rides In The Area\n\nPark your car, put on your helmet, fill your water bottle, and discover the best way to see the sights of Michigan—on two wheels. Biking is fun for the whole family, and whether you're a dedicated cyclist or just want to have some fun with the kids on the weekend, a bike and a couple of hours are all you need to enjoy the carefully selected routes in this well-researched guide."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/1675233a4e215882c90ff8911a29c5ea.png"
            alt="Books Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/30"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">Books</h1>
          <p className="text-xl text-white mt-4 font-light">Travel guides, wine country tours, and lifestyle companions</p>
        </div>
      </section>

      {/* Books Grid */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-light text-black mb-16 tracking-tight text-center">Nonfiction Books by Pamela Stovall</h2>
          
          <div className="space-y-24">
            {books.map((book, index) => (
              <div key={index} className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-start ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <div className="w-full h-[500px] bg-gray-100 flex items-center justify-center">
                    <img 
                      src={book.image}
                      alt={book.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
                
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  <h2 className="text-3xl font-light text-black mb-2 tracking-tight">{book.title}</h2>
                  {book.subtitle && (
                    <p className="text-lg text-gray-700 mb-4 italic">{book.subtitle}</p>
                  )}
                  <p className="text-sm text-gray-500 mb-6">
                    by {book.author}{book.publisher && `, ${book.publisher}`}
                  </p>
                  
                  {book.quote && (
                    <div className="bg-gray-50 p-6 mb-6">
                      <p className="text-base text-gray-800 leading-relaxed italic mb-2">
                        "{book.quote}"
                      </p>
                      <p className="text-sm text-gray-600">
                        — {book.quoteAuthor}
                      </p>
                    </div>
                  )}
                  
                  <div className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                    {book.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-light text-black mb-4 tracking-tight">Stay Updated</h2>
          <p className="text-gray-700 text-base mb-8">
            Join my mailing list to receive updates about new releases, exclusive content, and upcoming events.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input 
              type="email" 
              placeholder="Your email address"
              className="flex-1 px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-black"
            />
            <button 
              type="submit"
              className="px-6 py-3 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join List
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
